import { getCurrencyCountryCode } from '@dealstack/shared/lib/format/currency/currency';
import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import {
	ComparatorContainer,
	CurrencyWithFlag,
	FXExchangeRateRow,
	FXRatesFormContainer,
} from './styled';
import { LiveRateSection } from '@dealstack/frontend/app/pages/Valuations/views/EditValuation/FXRatesDrawer/components/LiveRateSection';
import { EditableRateSection } from '@dealstack/frontend/app/pages/Valuations/views/EditValuation/FXRatesDrawer/components/EditableRateSection';
import ReactCountryFlag from 'react-country-flag';
import {
	makeComplexDataTestId,
	VALUATION_ELEMENT_ID,
} from '@dealstack/shared/tests/testElementIds';
import { CurrencyType } from '@dealstack/shared/lib/generated';

interface Props {
	children?: React.ReactNode;
	defaultCurrency: CurrencyType | undefined;
	currencies: CurrencyType[];
	latestFxRates: Partial<Record<CurrencyType, number>>;
}

export const RateList = ({ children, defaultCurrency, currencies, latestFxRates }: Props) => {
	return (
		<FXRatesFormContainer>
			{currencies.map((currency, index) => {
				const countryCode = getCurrencyCountryCode(currency);

				return (
					<FXExchangeRateRow
						data-testid={makeComplexDataTestId(
							VALUATION_ELEMENT_ID.FX_EXCHANGE_RATE_ROW,
							currency
						)}
						key={currency}
						$disableBorder={currencies.length - 1 === index}
					>
						<CurrencyWithFlag
							data-testid={VALUATION_ELEMENT_ID.FX_EXCHANGE_RATE_CURRENCY_WITH_FLAG}
						>
							{countryCode && (
								<ReactCountryFlag
									countryCode={countryCode}
									svg
									style={{
										width: '1em',
										height: '1em',
									}}
									title={countryCode}
								/>
							)}
							<TextV2 variant="sans/14/400">{currency}</TextV2>
						</CurrencyWithFlag>
						<ComparatorContainer>
							<LiveRateSection
								data-testid={VALUATION_ELEMENT_ID.FX_EXCHANGE_LIVE_RATE}
								liveRate={latestFxRates[currency]}
							/>
							<EditableRateSection
								data-testid={VALUATION_ELEMENT_ID.FX_EXCHANGE_RATE_AT_VALUATION}
								currency={currency}
								isEditable={defaultCurrency !== currency}
							/>
						</ComparatorContainer>
					</FXExchangeRateRow>
				);
			})}
			{children}
		</FXRatesFormContainer>
	);
};
